<template>
  <el-container class="branch-performance-analysis pagination-list">
    <el-main>
      <div class="content">
        <el-col :span="22" class="branch-performance-analysis-search">
          <el-form>
            <el-form-item label="所属分公司" label-width="90px">
              <el-input :title="filiale" v-model="filiale" placeholder="总公司" readonly @click.native.prevent="openDialog"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="search" size="mini">生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <div class="echarts-bar-line" ref="echartsBarLine"></div>
        <select-filiale-dialog
          :dialogVisible="dialogVisible"
          :default-checked-keys="['0005A41F-0000-0000-0000-0000FDA5314A']"
          @setFiliale="setFiliale"
          @setSelectList="setSelectList"
          @closeDialog="closeDialog"></select-filiale-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import SelectFilialeDialog from './publicDialog/select-filiale-dialog.vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
Vue.use(echarts)

export default {
  name: 'branch-performance-analysis',
  components: {SelectFilialeDialog},
  data () {
    return {
      dialogVisible: false,
      // 已选分公司
      selectList: [],
      filiale: ''
    }
  },
  mounted () {
    this.drawEcharts()
    // 监听窗口大小变化重绘echarts
    window.onresize = _.debounce(() => {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.resize()
    }, 100)
  },
  methods: {
    drawEcharts () {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.setOption({
        title: {
          text: '分公司30日业绩分析',
          textStyle: {
            color: '#2A2929',
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            snap: 'true'
          }
        },
        grid: {
          bottom: 50
        },
        legend: {
          bottom: 0,
          itemGap: 100,
          formatter: (name) => {
            if (name.indexOf('额') !== -1) {
              return name + '/万'
            } else {
              return name + '/件'
            }
          },
          data: [
            {
              name: '销售额'
            },
            {
              name: '销售件数'
            }]
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 9
          }
        },
        yAxis: [{
          minInterval: 1,
          axisLabel: {
            formatter: '{value}件'
          }
        }, {
          axisLabel: {
            formatter: '{value}万'
          }
        }],
        series: [
          {
            name: '销售件数',
            type: 'line',
            yAxisIndex: 0,
            itemStyle: {
              color: '#ED7D31'
            }
          },
          {
            name: '销售额',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#5B9BD5'
            }
          }
        ]
      })
    },
    openDialog () {
      this.dialogVisible = true
    },
    // 当前选中分公司
    setFiliale (filiale) {
      this.filiale = filiale
    },
    setSelectList (selectList) {
      this.selectList = selectList
      this.dialogVisible = false
    },
    closeDialog () {
      this.dialogVisible = false
    },
    // 按日期排序从后端获得的数据
    formatterData (data) {
      let orderData = {}
      Object.keys(data).sort().forEach(key => {
        orderData[key] = data[key]
      })
      return orderData
    },
    search () {
      let deptIds = this.selectList.map(e => e.id)
      let data = {
        deptIds: deptIds
      }
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.showLoading({
        text: '加载中...',
        color: '#47A2FF',
        textColor: '#47A2FF',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      })
      this.$axios.post('/huaao-api/visualReport/filaleSaleCount30Day', data).then(res => {
        let line = this.formatterData(res.data.lineChart)
        let bar = this.formatterData(res.data.histogram)
        let xAxisData = []
        let barYAxis = []
        let lineYAxis = []
        // 设置x轴及折线图数据
        Object.keys(line).forEach(key => {
          xAxisData.push(key)
          lineYAxis.push(line[key] || 0)
        })
        // 设置柱状图数据
        Object.keys(bar).forEach(key => {
          barYAxis.push((bar[key] / 10000) || 0)
        })
        myCharts.setOption({
          xAxis: {
            data: xAxisData
          },
          series: [
            {
              data: lineYAxis
            },
            {
              data: barYAxis
            }
          ]
        })
        myCharts.hideLoading()
      }).catch(() => {
        myCharts.hideLoading()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .el-container.branch-performance-analysis {
    .content {
      height: calc(100% - 80px);

      .branch-performance-analysis-search {
        .el-form {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: scroll;
          height: 46px;
          .el-form-item{
             flex: 0 1 auto;
           }
          .el-form-item:nth-of-type(4){
            margin-left: 10px;
          }
          .el-form-item:last-of-type{
            margin-left: 50px;
          }
        }
        .el-button{
          padding: 4px 10px;
          border-color: #55ACF1;
          color: #55ACF1;
          span{
            font-size: 12px;
          }
        }
      }
      .echarts-bar-line{
        width: 92%;
        height: 92%;
        min-width: 800px;
        min-height: 600px;
        margin: 50px auto 0;
      }
      .select-filiale{
        .dialog-content {
          height: 500px;
          overflow: auto;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/branch-performance-analysis.vue